<template lang="html">

  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation" v-bind:id="id" >
    <div class="navbar-brand">
      <a class="navbar-item largedevice" href="/">
        <span class="is-hidden-tablet">
        <img v-if="!isDark" :src="(config.squareLogo && config.squareLogo.img)"/>
        <img v-if="isDark" :src="(config.squareLogo && (config.squareLogo.darkImg || config.squareLogo.img))"/>
        </span>
      
        <span class="is-hidden-mobile">
        <img v-if="!isDark" :src="config.logo && config.logo.img"/>
          <img v-if="isDark" :src="(config.logo && config.logo.darkImg) || (config.logo && config.logo.img)"/>
        </span>
      </a>

      <a class="navbar-item largedevice is-hidden-tablet" v-for="(tab, index) in config.tabs" v-bind:key="tab.order" style="padding-right: 0.65rem; padding-left: 0.65rem;" v-bind:class="{ 'is-active has-text-white': tab.name==activeTab }" v-on:click="tabClick(index)" v-if="isTabVisible(tab)">
        <span class="icon" v-if="tab.icon"><i class="fas" v-bind:class="'fa-'+tab.icon"></i></span>
      </a>

      <a class="navbar-item largedevice" v-if="$store.getters.isAdmin">
          <span class="icon" v-on:click="switchEditProps()"><i class="fas fa-pencil"></i></span> 
      </a>

      <a v-if="!isDesktop" class="navbar-item notification" style="position: static;">
        <notificationManager></notificationManager>
      </a>

      <a class="navbar-burger" role="button" aria-label="menu" aria-expanded="false"  v-bind:class="{ 'is-active':burger_open }" v-on:click="burger_open=!burger_open">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <!-- burger opened only -->
    <div class="navbar-menu" v-bind:class="{ 'is-active':burger_open }">
      <div class="navbar-start">
        
        <!-- <a class="navbar-item" href="/" v-if="!burger_open">
          <img v-if="!isDark" :src="config.logo && config.logo.img"/>
          <img v-if="isDark" :src="(config.logo && config.logo.darkImg) || (config.logo && config.logo.img)"/>
        </a> -->

        <a class="navbar-item" v-for="(tab, index) in config.tabs" v-bind:key="tab.order" v-bind:class="{ 'is-active has-text-white': tab.name==activeTab }" v-on:click="tabClick(index)" v-if="isTabVisible(tab)">
          <span v-if="editmode">{{ index }}:</span>{{ $t(tab.name) }}
        </a>
      </div>
      <div class="navbar-end" v-if="!burger_open">
        <a class="navbar-item"  v-if="$store.getters.isAdmin">
            <span class="icon" v-on:click="switchEditProps()"><i class="fas fa-pencil"></i></span> 
        </a>

        <a v-if="isDesktop" class="navbar-item notification" style="position: static">
          <notificationManager></notificationManager>
        </a>
      </div>
    </div>
    <bulmaP></bulmaP>
    <bulmatabprops class="test" v-if="showModal" v-on:change="setTabName($event)" v-on:cancel="showModal=false" v-bind:isnew="isnew" v-bind:tab="tab"></bulmatabprops>
    
  </nav>

</template>

<script>
import bulmatabprops from '../components/bulma_tabprops.vue'
import notificationManager from '../components/notificationManager.vue'
import bulmaP from '../components/bulma_p.vue'
export default {
  name: 'bulmaTabBar',
  components: {
    bulmatabprops,
    notificationManager,
    bulmaP,
  },
  props: {
    id: String,
    data: Object,
  },
  data() {
    return {
      showModal: false,
      isnew: false,
      tabindex: 0,
      tab: {
        name: '',
        path: '',
        index: -1
      },
      burger_open: false,
      isDesktop: false, // 3. Track screen state
    }
  },
  watch: {
    process: function (newVal) {
      if (!newVal) newVal = '/'; else newVal = '/' + newVal;
      this.setActiveOnPath(newVal);
    },
  },
  computed: {
    process: function() {
      return this.$store.state.global_state_process;
    },
    config: function() {
      return this.$store.getters.getObject(this.id).data;
    },
    activeTab() {
      var tab = this.config.tabs.find( t => t.path == '/'+this.process )
      return (tab && tab.name) || this.config.active_tab
    },
    editmode: function() {
      return this.$store.getters.getEditMode(this.id);
    },
    romode: function() {
      return this.$store.getters.getROMode(this.id);
    },
    isDark() {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return true
      return false
    },
    safeConfig() {
      return this.config || {};
    },
    hasLogo() {
      return this.safeConfig.logo && this.safeConfig.logo.img;
    }
  },
  mounted() {
    let newVal = this.process;
    if (!newVal) newVal = '/'; else newVal = '/' + newVal;
    this.setActiveOnPath(newVal);

    // 4. Listen to the browser viewport layout alterations
    this.mediaQuery = window.matchMedia('(min-width: 1024px)');
    this.isDesktop = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
  },
  beforeDestroy() {
    // 5. Clean up the resize listener to avoid memory leaks
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
    }
  },
  methods: {
    handleBreakpointChange(event) {
      this.isDesktop = event.matches;
    },
    isTabVisible: function (tab) {
      if (!tab.apps) return true;
      // TODO myprofile.teams also from here
      if (!this.$store.state.myprofile || !this.$store.state.myprofile.teams) return false;
      
      // Controlla se almeno uno dei team dell'utente ha un'app abilitata che corrisponde a una delle app del tab
      return this.$store.state.myprofile.teams.some(team => {
        if (!team.Team__r || !team.Team__r.App_abilitata__c) return false;
        
        // Controlla se l'app abilitata del team è inclusa nelle app del tab
        // O se il tab include 'default' (che lo rende visibile per tutti i team con qualsiasi App_abilitata__c)
        return tab.apps.includes(team.Team__r.App_abilitata__c) || tab.apps.includes('default');
      });
    
    },
    setActiveOnPath: function(newVal) {
      let t=this.config.tabs.find( (t) => { return t.path==(newVal) })
      if (t) this.updateConfig("active_tab", t.name);
      else this.updateConfig("active_tab", '')
    },
    // saveConfig: function () {
    //   console.log('saveConfig');
    // },
    // gotoEditMode: function (flag) {
    //   var payload = { id: this.id, editmode: flag };
    //   this.$store.commit('SET_EDITMODE', payload);
    // },
    updateConfig: function (name, val) {
      var c = this.config;
      c[name] = val;
      var payload = { id: this.id, cfg: { id: this.id, type: this.type, data: c } }
      this.$store.commit('SET_CONFIG', payload);
    },
    setTabName: function (tab) {
      this.showModal = false;
      if (this.isnew) {
        this.$emit('add', tab);
      } else {
        this.$emit('change', tab);
      }
    },
    newTab: function() {
      this.isnew=true;
      this.showModal=true;
      this.tab.name='';
      this.tab.path='';
      this.tab.index=-1;
    },
    tabClick: function(tabindex) {
      this.burger_open=false;
      var t=this.config.tabs[tabindex];
      if (!this.editmode) {
        this.updateConfig("active_tab", t.name);
        this.$router.push(t.path);
        this.$emit('click', t);
      } else {
        this.tab.index=tabindex;
        this.tab.name=t.name;
        this.tab.path=t.path;
        this.isnew=false;
        this.showModal=true;
      }
    },
    switchEditProps: function(){
      this.$store.dispatch('switchEditProps');
    },
    
    
  }
}
</script>

<style scoped>
.notification{
  /* padding-left:0%;
  padding-right:0%;
  padding-top: 3%;
  padding-bottom:0%; */
  --bulma-navbar-item-hover-background-l-delta: rgba(0, 128, 0, 0) !important;
  position: static !important;
  margin-bottom: 0;

}




</style>
